import { cn } from '@/lib/utils';
import failIcon from '@/assets/x.svg';
import { payButtonClass } from './paymentFormClasses';

interface Props {
  /** Clear the failed intent and re-mint for the same amount. */
  onRetry: () => void;
}

/**
 * Bottom-sheet content for a failed deposit. The primary CTA re-mints a fresh
 * payment session for the same amount; the secondary opens a support email.
 */
export function DepositFail({ onRetry }: Props) {
  return (
    <div className="flex flex-col items-center text-center" role="status" aria-live="polite">
      <h2 className="text-[34.2px] font-semibold leading-normal text-ink">Oops!</h2>
      <p className="mt-3.5 max-w-[377px] text-[21.6px] leading-[34px] text-ink">
        You may try a different payment method or contact your bank for further assistance.
      </p>
      <img src={failIcon} alt="" aria-hidden className="my-10 size-[140px] motion-safe:animate-deposit-pop" />
      <button type="button" onClick={onRetry} className={cn(payButtonClass, 'h-[50px] w-[270px] text-[21.6px] capitalize')}>
        Try Again
      </button>
      <a
        href="mailto:support@sunfltd.com"
        className="mt-3 text-[21.6px] leading-[34px] text-purple underline transition-opacity hover:opacity-80"
      >
        Contact Support
      </a>
    </div>
  );
}
